module.exports = __webpack_public_path__ + "static/ETCH_PITA_EMPTY-4f9c5fbc77da40192e124bb90fc8cb48.gif";